















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import DeepCopy from '@/decorators/deep-copy';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired, validateMod11, validateLength } from '../UI/Form/Validations';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnitDepartments, GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { GQL_createSubUnitVariables } from '@/queries/__generated__/createSubUnit';
import { ALL_SUBUNITS } from '@/queries/SubUnit';
import { GQL_currentUnitSubUnits } from '@/queries/__generated__/currentUnitSubUnits';

@Component
export default class SubUnitForm extends Vue {
  @SmartQuery<SubUnitForm, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
  }) private departments!: GQL_currentUnitDepartments_currentUnit_departments[];

  @SmartQuery<SubUnitForm, GQL_currentUnitSubUnits>({
    query: ALL_SUBUNITS,
    update(data) {
      return data
        .currentUnit
        .subUnits
        .filter(p => p.organizationNumber !== (this as SubUnitForm).formData.organizationNumber)
        .map(u => u.organizationNumber);
    },
  }) private usedOrganizationNumbers!: string[];

  @DeepCopy('data') private formData!: GQL_createSubUnitVariables;
  @Prop(Object) private data!: GQL_createSubUnitVariables;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) private query!: any;

  private validForm = true;

  private rules: IRules = {
    name: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('SubUnit', 'name') }),
      },
    ],
    organizationNumber: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('SubUnit', 'organizationNumber') }),
      },
      {
        validation: ({ dataValue }) => !this.usedOrganizationNumbers.includes(dataValue),
        message: i18n => i18n.t('Error.alreadyTaken', { field: this.t_attr('SubUnit', 'organizationNumber') }),
      },
      {
        validation: validateMod11(),
        message: i18n => i18n.t('Error.invalid', { field: this.t_attr('SubUnit', 'organizationNumber') }),
      },
      {
        validation: validateLength(9),
        message: i18n => i18n.t('Error.length', { field: this.t_attr('SubUnit', 'organizationNumber'), length: 9 }),
      },
    ],
  };

  @Emit()
  private mutationDone() {}
}
